import React, { useState } from 'react';
import { Table, Button } from 'react-bootstrap';
import { SpinnerLoader } from "../Preloader";
import { getDateTime } from '../../utils/dateFormatter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-regular-svg-icons';

const ApkTable = ({ loading, data }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = (url) => {
        navigator.clipboard.writeText(url);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Hide message after 2s
    };

    return (
        <div className="TableBg mt-4 p-0">
            <div className="CustomTableWrapper">
                <div className="table-scroll-wrapper">
                    <div className="table-responsive">
                        {loading ? (
                            <div className='w-full d-flex justify-content-center align-items-center'>
                                <SpinnerLoader />
                            </div>
                        ) : (
                            <Table striped hover table-borderless size="sm" bordered className="text-center mt-3">
                                <thead className="thead-light">
                                    <tr>

                                        <th>S.No</th>
                                        <th>File Name</th>
                                        <th>Size</th>
                                        <th>APK URL</th>
                                        <th>Uploaded At</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data?.apkData?.apkUrl ? (
                                        <tr key={data?.apkData?.apkUrl}>

                                            <td>{"1"}</td>
                                            <td style={{ maxWidth: '200px' }} className="text-truncate">
                                                {data?.apkData?.originalName}
                                            </td>
                                            <td>
                                                {data?.apkData?.fileSize
                                                    ? `${(data.apkData.fileSize / (1024 * 1024)).toFixed(2)} MB`
                                                    : "N/A"}
                                            </td>
                                            <td style={{ maxWidth: '250px', whiteSpace: 'normal', wordBreak: 'break-all' }}>
                                                {copied && (
                                                    <span className="ms-2 " style={{ fontSize: '0.9rem', color: '#0d6efd' }}>
                                                        Copied!
                                                    </span>
                                                )}
                                                <div className="d-flex align-items-center">
                                                    <p
                                                        className="mb-0 flex-grow-1"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => handleCopy(data?.apkData?.apkUrl)}
                                                    >
                                                        {data?.apkData?.apkUrl}
                                                    </p>

                                                    <FontAwesomeIcon
                                                        icon={faCopy}
                                                        className={`ms-2 `}
                                                        style={{

                                                            cursor: "pointer",
                                                            fontSize: "1rem",
                                                            color: copied ? "#0d6efd" : "#6c757d", // blue when copied, grey default

                                                            transition: "transform 0.2s ease, color 0.2s ease",
                                                            transform: copied ? "scale(1.1)" : "scale(1)",
                                                        }}
                                                        onClick={() => handleCopy(data?.apkData?.apkUrl)}
                                                    />


                                                </div>
                                            </td>
                                            <td>{getDateTime(data?.apkData?.uploadedAt)}</td>
                                        </tr>
                                    ) : (
                                        <tr>
                                            <td colSpan={6}><p>No APKs found.</p></td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ApkTable;
